import { useState, useEffect, useRef } from 'react';
import { Button, Col, Row, Tab, Tabs } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';

import Trash from "../../../assets/images/delete.svg";
import { toast } from 'react-toastify';
import { withRFSToken } from '../../../Services/axios.js';
import { SLOTPLANNINGWAREHOUSE, SLOTPLANNINGRESOURCEADDUPDATE, SLOTPLANNINGRESOURCELIST, SLOTPLANNINGRESOURCEDELETE } from '../../../Utils/conts.js';

const ResourceSettings = () => {
  const [truckRows, setTruckRows] = useState([
    { id: Date.now(), start_time: '', end_time: '', truck: '' },
  ]);
  const isMounted = useRef(false);
  const [warehouselist, setWarehouselist] = useState([]);
  const [activeWarehouse, setActiveWarehouse] = useState(null);

  useEffect(() => {
    if (isMounted.current) return;
    fetchWareHouseData();
    isMounted.current = true;
  }, []);

  const handleInputChange = (index, field, value) => {
    const updated = [...truckRows];
    updated[index][field] = value;
    setTruckRows(updated);
  };

  const addTruckRow = () => {
    setTruckRows([
      ...truckRows,
      { id: null, start_time: '', end_time: '', slot_count: '' },
    ]);
  };

  const removeTruckRow = async (index) => {
    const row = truckRows[index];
    if (row.id) {
      try {
        const res = await withRFSToken.post(SLOTPLANNINGRESOURCEDELETE, { id: row.id });
        if (res.data.response_code === 200) {
          toast.success(res.data.response_msg);
          const updated = truckRows.filter((_, i) => i !== index);
          setTruckRows(updated);
        } else {
          toast.error(res.data.response_msg);
        }
      } catch (error) {
        console.error('Error deleting resource row:', error);
        toast.error('Failed to delete resource.');
      }
    } else {
      const updated = truckRows.filter((_, i) => i !== index);
      setTruckRows(updated);
    }
  };

  const fetchWareHouseData = async () => {
    try {
      let Handler_stn = localStorage.getItem('Handler_stn');
      if (!Handler_stn) {
        return;
      }
      Handler_stn = JSON.parse(Handler_stn);
      const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSE, { org_station_id: Handler_stn.org_station_id })
      const innerData = res.data.response_data;
      setWarehouselist(innerData.map(w => ({
        label: w.name,
        value: w.id,
        doors_count: w.doors_count,
      })));
      if (innerData.length > 0) {
        const firstId = innerData[0].id;
        setActiveWarehouse(firstId);
        fetchWarehouseResources(firstId);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };

  const fetchWarehouseResources = async (warehouseId) => {
    try {
      const res = await withRFSToken.post(SLOTPLANNINGRESOURCELIST, { warehouse_id: warehouseId });
      const data = res.data.response_data || [];
      setTruckRows(data.length > 0
        ? data.map(item => ({
          id: item.id || null, // API-provided ID
          start_time: item.start_time || '',
          end_time: item.end_time || '',
          slot_count: item.slot_count || '',
        }))
        : [{ id: null, start_time: '', end_time: '', slot_count: '' }]
      );
    } catch (error) {
      console.error('Error fetching warehouse resources:', error);
      toast.error('Failed to load truck resources.');
    }
  };

  const handleWarehouseClick = (warehouseId) => {
    setActiveWarehouse(warehouseId);
    fetchWarehouseResources(warehouseId);
  };

  const handleSave = async () => {
    const payload = {
      warehouse_id: activeWarehouse,
      warehouse_resources: truckRows.map(({ id, start_time, end_time, slot_count }) => ({
        id: id ?? null, // always send null if it's undefined
        start_time,
        end_time,
        slot_count,
      })),
    };
    try {
      const res = await withRFSToken.post(SLOTPLANNINGRESOURCEADDUPDATE, payload);
      if (res.data.response_code == 200) {
        toast.success(res.data.response_msg);
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error saving truck data:', error);
      toast.error('Failed to save truck data.');
    }
  };

  const SBack = localStorage.getItem('SettingsBack');

  return (
    // <div className="">
    //   <Header logo_url={SBack ? SBack : '/PlanningDashboard'} sBackUrl={SBack ? SBack : '/PlanningDashboard'} />
    //   <div className="main-panel">
    //     <div className="row">
    //       <LeftSettings />
    // <div className='col-9 col-xxl-9 stting_right'>
    // <div className='settingbg_right'>
    <div className='slot_setting_right'>
      <h4>Resource Settings</h4>
      <p>Manage and configure doors to add them to your system</p>
      <hr />
      <Tabs
        id="warehouse-tabs"
        activeKey={activeWarehouse}
        onSelect={handleWarehouseClick}
        className="booking_tab"
      >
        {warehouselist?.map((warehouse) => (
          <Tab
            eventKey={warehouse.value}
            key={warehouse.value}
            title={<span>{warehouse.label}</span>}
          />
        ))}
      </Tabs>
      <div className='resource_seting'>
        <div className="handle_truck">
          <h5>Handle Truck</h5>
          <Button variant="link" onClick={handleSave} className='edit_btn'>Save</Button>
        </div>

        <div className='handler_body'>
          {truckRows.map((row, index) => (
            <Row key={row.id} className="mb-3 align-items-center">
              <Col sm="3">
                <input
                  type="time"
                  value={row.start_time}
                  onChange={(e) => handleInputChange(index, 'start_time', e.target.value)}
                  className="form-control"
                />
              </Col>
              <Col sm="1" className="text-center">---</Col>
              <Col sm="3">
                <input
                  type="time"
                  value={row.end_time}
                  onChange={(e) => handleInputChange(index, 'end_time', e.target.value)}
                  className="form-control"
                />
              </Col>
              <Col sm="1" className="text-center">==</Col>
              <Col sm="2">
                <input
                  type="text"
                  value={row.slot_count}
                  onChange={(e) => handleInputChange(index, 'slot_count', e.target.value)}
                  className="form-control"
                  placeholder="Truck No."
                />
              </Col>
              <Col sm="1">
                {truckRows.length > 1 && (
                  <img
                    src={Trash}
                    onClick={() => removeTruckRow(index)}
                    style={{ cursor: 'pointer', width: '20px' }}
                    alt="Delete"
                  />
                )}
              </Col>
            </Row>
          ))}

          <Button variant="link" onClick={addTruckRow} >+ Add Truck </Button>
        </div>
      </div>
    </div>
    // </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default ResourceSettings;
